import { toast } from 'react-toastify';

const getHeaders = (includeContentType: boolean) => {
  const headers = new Headers();

  if (includeContentType) {
    headers.append('Content-Type', 'application/json');
  }

  return headers;
};

export function handleError(error: string) {
  toast.error(error);
}

export function handleErrors(errors: string[]) {
  errors.forEach((error) => handleError(error));
}

async function api(
  url: string,
  fetchOptions: RequestInit
): Promise<ApiResponse> {
  return fetch(url, fetchOptions).then(async (response) => {
    if (!response.ok) {
      handleError('An error occurred, please try again');
    }

    return Promise.resolve({
      status: response.status,
      success: response.ok,
      data: response.json(),
    });
  });
}

export async function get(url: string) {
  return api(url, {
    headers: getHeaders(false),
    method: 'GET',
  });
}

export async function getWithOptions(url: string, options: RequestInit = {}) {
  return api(url, {
    ...options,
    headers: getHeaders(false),
    method: 'GET',
  });
}

export async function post(url: string, options: RequestInit = {}) {
  return api(url, {
    ...options,
    headers: getHeaders(true),
    method: 'POST',
  });
}
